app.directive('modalWrapper',["$compile", "$document", function ($compile, $document) {

	var jqLite = angular.element;

	/*
	Modal window template
	*/
	var template =
		'<div id="dimmer-fullscreen" class="ui dimmer modals page transition visible active">' +
			'<div id="modal-fullscreen" class="ui fullscreen active modal">' +
				'<span class="btn-close-fullscreen"><i class="compress icon" ng-click="close()"></i></span>' +
				'<div class="content modal-body"></div>' +
			'</div>'+
		'</div>';


	var link = function (scope, element) {
		scope.open();

		scope.$watch('showModal', function (newVal) {
			// watch when modal being opened
			var modalEl = jqLite('modal-wrapper');
			var fullscreenIcon = modalEl.find('[name="fullscreen"]');
			// Modal being opened
			if (newVal) {
				// Hide fullscreen icon in modal
				fullscreenIcon.addClass("ng-hide");
				modalEl[0].parentNode.insertBefore(element[0], modalEl[0]);
				var content = modalEl.children();
				element.find(".modal-body").append(content);
				// Remove <modal-wrapper> tag
				modalEl.remove();
				// Make modal visible
				jqLite('#modal-fullscreen').show();
				// changing element's width
				content.addClass('expand');

			} else if (!newVal) {
				// Modal being closed
				fullscreenIcon.removeClass("ng-hide"); // show expand icon
				var modalBody = modalEl.find(".modal-body").children();
				modalEl[0].parentNode.insertBefore(modalBody[0], modalEl[0]);
				modalEl.remove();
				modalBody.removeClass('expand');
			}
		});
	};


	return {
		restrict: 'E',
		scope: {},
		template: template,
		link: link,
		controller:  ['$scope', function ($scope) {
			$scope.open = function () {
				$scope.showModal = true;
			};
			$scope.close = function () {
				$scope.showModal = false;
			};

			// Close modal when back button's clicked
			$scope.$on('$locationChangeStart', function(event) {
				if ($scope.showModal) {
					event.preventDefault();
					$scope.close();
				}
			});
		}]
	};

}]);
